import React, { Component } from 'react';
// import EmailImg from '../../img/email.svg'

class LineInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            focus: false,
            blur: false,
        }
    }

    getBorderColor = () => {
        if (this.state.focus) {
            return window.color.searchBoxBgColor;
        }
        if (this.state.blur) {
            if (this.props.validation === 'email' && !(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.props.value))) {
                return 'red';
            }
            if (this.props.validation === 'mobile' && (this.props.value < 6000000000 || (this.props.value + '').length !== 10)) {
                return 'red';
            }
            if (!this.props.value || this.props.value === '') {
                return 'red';
            }
        }
        return '#ddd';
    }

    render() {
        return (
            <div style = {{ ...this.props.style, position: 'relative' }}>
                <input
                    type = { this.props.type }
                    value = { this.props.value }
                    onFocus = { () => this.setState({ focus: true, blur: false }) }
                    onBlur = { () => this.setState({ focus: false, blur: true }) }
                    onChange = { this.props.handleChange }
                    tabIndex = { this.props.tab }
                    name = { this.props.name }
                    maxLength = { this.props.max }
                    autoFocus = { this.props.tab === 1 }
                    style = {{
                        background: 'transparent',
                        border: 0,
                        outline: 0,
                        width: '100%',
                        padding: this.props.isImg ? '20px 0 5px 40px' : '20px 0 5px',
                        color: '#444',
                        fontWeight: '300',
                        borderBottom: '1px solid',
                        borderColor: this.getBorderColor(),
                        transition: '0.3s ease'
                    }}
                />
                <label style = {{
                    position: 'absolute',
                    left: this.props.isImg ? '40px' : '0',
                    fontSize: this.state.focus || (this.props.value + '').length > 0 ? '0.7rem' : 'inherit',
                    bottom: this.state.focus || (this.props.value + '').length > 0 ? '25px' : '5px',
                    transition: '0.3s ease',
                    pointerEvents: 'none',
                    color: this.state.focus || (this.props.value + '').length > 0 ? window.color.searchBoxBgColor : 'inherit'
                }}>
                    { this.props.placeholder }
                </label>
                { this.props.isImg ? <img src = { '/img/email.svg' } alt = 'email' style = {{ position: 'absolute', left: 0, bottom: 0 }} /> : '' }
            </div>
        )
    }
}

export default LineInput;